// export const apiBaseUrl = process.env.REACT_APP_ORDER_API_URL
export const apiBaseUrl = "https://crm.sundreamcapital.com/api"
export const crmApiBaseUrl = process.env.CRM_API_URL
export const apiKey = process.env.REACT_APP_ORDER_API_KEY
export const token = localStorage.getItem('token');
export const logoLight = "https://crm.sundreamcapital.com/assets/images/logoIcon/logo.png"
export const logoDark = "https://crm.sundreamcapital.com/assets/images/logoIcon/logo.png"

export const logoSm = "https://crm.sundreamcapital.com/assets/images/logoIcon/favicon.png"

const user = JSON.parse(localStorage.getItem('user'));
export const account = user ? user.account : null;